const functionsUrl = () => {
    if (window.location.hostname === "192.168.86.53") {
        return "http://localhost:5001/premises-2af49/us-central1";
    }

    return "https://us-central1-premises-2af49.cloudfunctions.net";
}

  
const mdmFunctionsBaseURL = functionsUrl() + '/app/mdm/'

const getOptions = function(idToken) {
    return {
        method: 'GET',
        headers: {
            "Authorization": "Bearer " + idToken,
        },
    };
}

const postOptions = function(idToken, body) {
    return {
        method: 'POST',
        headers: {
            "Authorization": "Bearer " + idToken,
            "Content-Type": "application/json",
        },
        body: body,
    };
}

export default {
    async getDevice(deviceId, idToken) {
        const urlEnd = 'devices/detail/?deviceId=' + deviceId;

        return fetch(mdmFunctionsBaseURL + urlEnd, getOptions(idToken)).then(function (res) {            
            return res.json();
        }).then(function (data) {
            return data;
        }).catch(e => console.log(e));
    },
    async shutdownDevices(deviceIds, idToken) {
        const urlEnd = 'devices/shutdown';

        return fetch(mdmFunctionsBaseURL + urlEnd, postOptions(idToken, JSON.stringify({"deviceIds": deviceIds}))).then(function (res) {        
            return res.json();
        }).then(function (data) {
            return data;
        });
    },
    async restartDevices(deviceIds, idToken) {
        const urlEnd = 'devices/restart';

        return fetch(mdmFunctionsBaseURL + urlEnd, postOptions(idToken, JSON.stringify({"deviceIds": deviceIds}))).then(function (res) {      
            return res.json();
        }).then(function (data) {
            return data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/MDMService.js